import { lazy, ReactElement, Suspense } from 'react';
import { Box, Spinner } from '@ff-it/ui';

const config = window.__RUNTIME_CONFIG__ as any;

const DeploymentQuotaAlerts = config?.HUB_ENABLED
  ? lazy(() =>
      import('./index').then((m) => ({
        default: m.DeploymentQuotaAlerts,
      })),
    )
  : null;

const AgencyQuotaAlert = config?.HUB_ENABLED
  ? lazy(() =>
      import('./index').then((m) => ({
        default: m.AgencyQuotaAlert,
      })),
    )
  : null;

const RefreshDeploymentQuota = config?.HUB_ENABLED
  ? lazy(() =>
      import('./index').then((m) => ({
        default: m.RefreshDeploymentQuota,
      })),
    )
  : null;

export function LazyDeploymentQuotaAlerts(): ReactElement | null {
  if (!DeploymentQuotaAlerts) {
    return null;
  }

  return (
    <Suspense
      fallback={
        <Box py="2" mx="auto">
          <Spinner color="primary" />
        </Box>
      }
    >
      <DeploymentQuotaAlerts />
    </Suspense>
  );
}

export function LazyAgencyQuotaAlert({ enterpriseId }: { enterpriseId: number }): ReactElement | null {
  if (!AgencyQuotaAlert) {
    return null;
  }

  return (
    <Suspense
      fallback={
        <Box py="2" mx="auto">
          <Spinner color="primary" />
        </Box>
      }
    >
      <AgencyQuotaAlert enterpriseId={enterpriseId} />
    </Suspense>
  );
}

export function LazyRefreshDeploymentQuota(): ReactElement | null {
  if (!RefreshDeploymentQuota) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <RefreshDeploymentQuota />
    </Suspense>
  );
}
